import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { SubstantiationRatePayload } from '../../Dashboard.type';

const QUERY_KEY = 'GET_SUBSTANTIATION_RATE';
const useSubstantiationRateQuery = () => {
  const {
    observingOrganization: { type, id },
    observingOrganizationData,
    loadedDefaultData,
  } = useCurrentOrganization({ isLoadDefaultOrgData: true });

  const isSubstantiationRate =
    _.get(observingOrganizationData, 'overridable_properties.substantiation_rate') ||
    _.get(loadedDefaultData, 'overridable_properties.substantiation_rate');
  const isSystemLevel = useMemo(() => type === OrganizationTypes.system, [type]);
  const { isLoading, data, isSuccess } = useQuery(
    [QUERY_KEY, isSubstantiationRate, id, type],
    () => api.get(API_URL.METRICS_CLAIMS_SUBSTANTIATION_RATE),
    {
      enabled: !isSystemLevel && !!isSubstantiationRate,
    }
  );
  const formattedData = useMemo<SubstantiationRatePayload | null>(() => {
    const responseData = data?.data;

    if (responseData) {
      return {
        ytd: responseData?.ytd || 0,
        thirtyDays: responseData?.thirty_days || 0,
        ninetyDays: responseData?.ninety_days || 0,
      };
    }

    return null;
  }, [data?.data]);
  const isEmpty = useMemo(() => {
    if ((isSuccess && !formattedData) || isSystemLevel || !isSubstantiationRate) {
      return true;
    }
    return false;
  }, [formattedData, isSubstantiationRate, isSuccess, isSystemLevel]);
  return {
    isLoading,
    isEmpty,
    isSuccess,
    data: formattedData,
  };
};
export default useSubstantiationRateQuery;
